import React from 'react'
import { Button as AntButton, Typography } from 'antd'
import isMobile from '../utils/isMobile'

export const SaltaButton = isMobile((props) => (
  <div className='fixed md:static bottom-0 flex left-0 w-full md:justify-start justify-around items-center submit-div md:px-0'>
    <div className='w-1/5 md:w-auto relative text-center pr-2'>
      <Typography.Text>{props.stepText}</Typography.Text>
    </div>
    <div className='md:w-4/5 lg:w-auto relative'>
      <AntButton
        htmlType='submit'
        className='my-4'
        type='default'
        loading={props.loading}
        block={props.isMobile}
        shape='round'
        onClick={props.onClick}
        style={{
          ...props.style,
          padding: '0 4rem',
          height: 54,
          color: '#439fa0',
          borderColor: '#439fa0'
        }}
      >
        <span className='uppercase'>Salta</span>
      </AntButton>
    </div>
  </div>
))

export const Button = isMobile((props) => (
  <div className='fixed md:static bottom-0 flex left-0 w-full md:justify-start justify-around items-center submit-div md:px-0'>
    <div className='w-1/5 md:w-auto relative text-center pr-2'>
      <Typography.Text>{props.stepText}</Typography.Text>
    </div>
    <div className='md:w-4/5 lg:w-auto relative'>
      <AntButton
        htmlType='submit'
        className='my-4'
        loading={props.loading}
        block={props.isMobile}
        shape='round'
        type='primary'
        onClick={props.onClick}
        style={{
          ...props.style,
          padding: '0 2rem',
          height: 54
        }}
      >
        <span className='uppercase'>{props.text}</span>
      </AntButton>
    </div>
  </div>
))

export const RiepilogoButton = isMobile((props) => (
  <div className='fixed md:static bottom-0 flex md:block left-0 w-full justify-center items-center z-50 submit-div'>
    <div className='w-4/5 lg:w-auto relative'>
      <AntButton
        htmlType='button'
        className='my-4'
        loading={props.loading}
        block={props.isMobile}
        shape='round'
        type='primary'
        onClick={props.onClick}
        style={{
          ...props.style,
          padding: '0 2rem',
          height: 54
        }}
      >
        <span className='uppercase'>{props.text}</span>
      </AntButton>
    </div>
  </div>
))
